import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

const apiFetchRouteModificationTransactions = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getRouteModificationTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
      impcCode: payload.params.impcCode,
    },
    queryStringParams: {
      numberOfDays: payload.params.numberOfDays,
    },
  });
  return axios.get(serviceUrl);
};

export default apiFetchRouteModificationTransactions;
